import React from "react";


export default function LoadBtn() {
    return(
        <div className="bttn">
            <button className="Butn">LOAD MORE</button>
        </div>
    )
}